import { clerk } from '@utils/clerk';

// send event for each page
window.addEventListener('load', () => {
  const isAppExists = document.getElementById('app');

  if (!window.SEND_PAGE_VIEW && !isAppExists) {
    window.SEND_PAGE_VIEW = true;
    clerk.sendPageView();
  }
});
